<div id="login">

  <h3>Log in:</h3>

  <form #f="ngForm" [formGroup]="loginForm" id="loginForm">
    <div class="form-group">
      <label>Email address</label>
      <input type="email" formControlName="email" class="form-control" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" required>
      <p class="errorText" *ngIf="!loginForm.controls.email.valid && loginForm.controls.email.touched">
        Email is required
      </p>
    </div>
    <div class="form-group">
      <label>Password</label>
      <input type="password" class="form-control" formControlName="password" >
      <p class="errorText" *ngIf="!loginForm.controls.password.valid && loginForm.controls.password.touched">
        Password is required
      </p>
      <label class="error">{{errorMessage}}</label>
      <label *ngIf="errorMessage">Forgot your password? <a [routerLink]="['/login/forgot-password']">Reset password</a></label>
    </div>
    <button id="loginButton" type="submit" [disabled]="!f.valid" (click)="tryLogin(loginForm.value)" class="btn btn-info">Login</button>
  </form>
    <div style="margin-bottom: 10px">

    <button id="logB" class="Dbutton" style="width: 240px;" (click)="loginWithGoogle()" mat-raised-button color="warn"><i class="fab fa-google"></i> Login with Google</button>
    
    <button id="logB1" class="Dbutton" style="margin-top: 20px;width: 240px;" (click)="loginWithFacebook()" mat-raised-button color="primary"><i class="fab fa-facebook-f"></i> FaceBook Login</button>
    <div>
      <p style="margin-top: 10px ;">No account yet? <a [routerLink]="['/login/register']">Create an account</a></p>
    </div>
  </div>


</div>

